export const CONSTANT = {
                            scorecard:{
                                            overall_feedback: '',
                                            score: '',
                                            score_hash:[{
                                                         link:'',
                                                         score: '',
                                                         job_competency_id: '',
                                                         job_competency_name: '',
                                                         job_sub_competencies:[{
                                                                                    job_sub_competency_id:'',
                                                                                    score:'',
                                                                                    job_sub_competency_name: ''

                                                                              }]
                                                       }],

                                            current_job_id:''
                                         }
                            
                        }